import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GraphService } from './graph.service';
import { Globals } from '../models/globals.model';
import { MsalService }from '@azure/msal-angular';
import { InteractionRequiredAuthError, AuthError } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root'
})

export class OverageService {

  groups: string[] = [];

  constructor(private readonly http: HttpClient, private readonly globals: Globals) {
  }

  readGraphGroups(authService: MsalService, service: GraphService, methodRef: (objRef: any) => void, objRef): void {
    service.getGroups().subscribe({
      next: (response: any) => {        
        this.handleGroupResponse(service, response, methodRef, objRef)
      },
      error: (err: AuthError) => {
        // If there is an interaction required error,
        // call one of the interactive methods and then make the request again.
        if (new InteractionRequiredAuthError(err.errorCode, err.errorMessage)) {
          authService.acquireTokenPopup({
            scopes: [this.globals.config.graphApi_client_resourceUri]
          })
            .subscribe(() => {
              service.getGroups()
                .toPromise()
                .then((response: any) => {                                  
                  this.handleGroupResponse(service, response, methodRef, objRef)
                });
            });
        }
      }
    });
  }

  handleGroupResponse(service: GraphService, response, methodRef: (objRef: any) => void, objRef) {
    response.value.map(v => this.groups.push(v.id));  
    if (response['@odata.nextLink']) {
      this.handleNextPageWithMethodRef(service, response['@odata.nextLink'], methodRef, objRef)      
    } else {
      this.syncGroupswithRef(service, methodRef, objRef);
    }
  }

  syncGroupswithRef(service: GraphService, methodRef: (objRef: any) => void, objRef) {
    service.user.groupIDs = this.groups;
    methodRef(objRef);
  }

  handleNextPageWithMethodRef(service: GraphService, nextPage, methodRef: (objRef: any) => void, objRef): void {
    service.getNextPage(nextPage)
      .subscribe((response: any) => {
        response.value.map(v => {
          if (!this.groups.includes(v.id)) {
            this.groups.push(v.id);
          }
        });
        if (response['@odata.nextLink']) {
          this.handleNextPageWithMethodRef(service, response['@odata.nextLink'], methodRef, objRef)
        } else {
          this.syncGroupswithRef(service, methodRef, objRef);
        }
      });
  }

}
